// initial state
const state = {
    dividedGroupList:[],
    serviceInfo:''
  };
  
  // getters
  const getters = {};
  
  // actions
  const actions = {};
  
  // mutations
  const mutations = {
    setDividedGroupList(state, dividedGroupList) {
      //设置参数
      state.dividedGroupList = dividedGroupList;
    },
    setServiceInfo(state, serviceInfo) {
      //设置参数
      state.serviceInfo = serviceInfo;
    }
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  };
  


// WEBPACK FOOTER //
// ./src/store/module/service.js